module.exports = __webpack_public_path__ + "static/media/Webp.net-gifmaker3.0f06d7ae.gif";